<template>
  <div class="card">
    <div class="detail_title">預訂內容</div>
    <div class="detail_container" id="summary">
      <div>
        {{ product.productName }}
      </div>
      <div class="pre_order_card">
        <table class="detail_table">
          <tbody>
            <tr>
              <td width="50%">產品編號：</td>
              <td class="right detail_number">
                {{ product.productCode }}
              </td>
            </tr>
            <tr>
              <td>收費計劃：</td>
              <td class="right">
                {{ product.price.rateTypeDescription }}
              </td>
            </tr>
            <tr>
              <td>車輛型號：</td>
              <td class="right">
                {{ product.carInfo.modelName }}
              </td>
            </tr>
            <tr>
              <td>車輛規格：</td>
              <td class="right">
                {{ product.carInfo.engineSpec }}
              </td>
            </tr>
            <tr>
              <td>取車日期：</td>
              <td class="right detail_number">{{ product.pickupDate }}</td>
            </tr>
            <tr>
              <td>取車時間：</td>
              <td class="right detail_number">{{ product.pickupTime }}</td>
            </tr>
            <tr>
              <td>取車地點：</td>
              <td class="right">{{ pickupBranch }}</td>
            </tr>
            <tr>
              <td>還車日期：</td>
              <td class="right detail_number">{{ product.returnDate }}</td>
            </tr>
            <tr>
              <td>還車時間：</td>
              <td class="right detail_number">{{ product.returnTime }}</td>
            </tr>
            <tr>
              <td>還車地點：</td>
              <td class="right">{{ returnBranch }}</td>
            </tr>
            <tr>
              <td>原價：</td>
              <td class="right detail_number">
                {{ product.price.currencyCode
                }}{{ product.price.originalPrice }}
              </td>
            </tr>
            <tr>
              <td>跨區金額：</td>
              <td class="right detail_number">
                {{ product.price.currencyCode
                }}{{ product.price.crossRegionCharge }}
              </td>
            </tr>
            <tr>
              <td>營業損失補償費用免責款保障(租車費已包)：</td>
              <td class="right detail_number">
                {{ product.price.currencyCode }}{{ product.price.nocCharge }}
              </td>
            </tr>
            <tr>
              <td>產品折扣：</td>
              <td class="right detail_number">
                -{{ product.price.currencyCode }}{{ product.price.discount }}
              </td>
            </tr>
            <tr>
              <td>額外服務：</td>
              <td class="right detail_number">
                {{ product.price.currencyCode }}{{ extraFee }}
              </td>
            </tr>
            <tr v-for="(item, idx) in carOptions" :key="idx">
              <td colspan="2">• {{ item.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="detail_total_amount">
      總額：{{ product.price.currencyCode }}
      <span class="detail_number" style="font-size: 22px">{{
        totalAmount
      }}</span>
    </div>
    <div class="detail_btn_group">
      <button
        type="button"
        :disabled="disabled"
        class="btn left"
        @click.stop="addToCart(true)"
      >
        立即購買
      </button>
      <button
        type="button"
        :disabled="disabled"
        class="btn right"
        @click.stop="addToCart(false)"
      >
        加入購物車
      </button>
    </div>
    <div class="detail_btn_group">
      <button
        type="button"
        class="btn"
        @click.stop="editCarRentalForm()"
        style="width: 100%; background: #aaedf3"
      >
        更改車款及行程
      </button>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import useEventBus from "@/config/eventBus";
import router from "@/router";
import moment from "moment";

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    pickupBranch: {
      type: String,
      required: true,
    },
    returnBranch: {
      type: String,
      required: true,
    },
    carOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const eventBus = useEventBus();
    const disabled = ref(false);
    const extraFee = ref(0);
    const days = ref(0);

    const totalAmount = computed(() => {
      const total =
        extraFee.value +
        props.product.price.sellingPrice +
        props.product.price.nocCharge +
        props.product.price.crossRegionCharge;
      return total;
    });

    const addToCart = (_bool) => {
      disabled.value = true;
      eventBus.emit("addCarRentalToCart", _bool);
      setTimeout(() => {
        disabled.value = false;
      }, 300);
    };

    const calculateExtraFee = (_carOptions) => {
      extraFee.value = 0;
      if (_carOptions.length > 0) {
        _carOptions.forEach((item) => {
          if (item.price != null && parseInt(item.price) > 0) {
            let price = item.price;
            if (item.rateType == "DAILY") {
              price = item.price * (days.value + 1);
            }
            if (item.rateType == "CAR") {
              price = item.price;
            }
            extraFee.value += parseInt(price);
          }
        });
      }
    };

    const editCarRentalForm = () => {
      router.push("/product/car-rental/edit");
    };

    watch(
      () => props.carOptions,
      (newVal) => {
        calculateExtraFee(newVal);
      }
    );

    onMounted(() => {
      days.value = moment(props.product.returnDate).diff(
        moment(props.product.pickupDate),
        "days"
      );
      console.log(days.value);
    });

    return { disabled, totalAmount, extraFee, addToCart, editCarRentalForm };
  },
};
</script>

